/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { GETCLUBSHIFTLIST, GETPERIOD } from './constants'
import { BEFORE_DAY, TODAY, NEXT_DAY } from '../../util/const'
import moment from 'moment'

export const getClubShiftList = (payload) => {
  return {
    type: GETCLUBSHIFTLIST,
    payload,
  }
}

export const getPeriod = (payload) => {
  return {
    type: GETPERIOD,
    payload,
  }
}

//交班报表
export function fetchClubShiftList(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BossApi/Shifting`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((res) => {
      dispatch(getClubShiftList(res.data))
      return res.data
    })
  }
}

export function fetchTimePeriod(type) {
  return (dispatch, getState) => {
    let startTime = new Date()
    let endTime = new Date()
    if (type == TODAY) {
      dispatch(
        getPeriod({
          start_time: moment(startTime).format('YYYY-MM-DD'),
          end_time: moment(endTime).format('YYYY-MM-DD'),
        })
      )
    } else {
      const { start_time, end_time } = getState().getClubShift.period
      if (type == BEFORE_DAY) {
        const st = moment(start_time).add(-1, 'days').format('YYYY-MM-DD')
        const et = moment(end_time).add(-1, 'days').format('YYYY-MM-DD')
        dispatch(getPeriod({ start_time: st, end_time: et }))
      } else if (type == NEXT_DAY) {
        if (
          moment(startTime).format('YYYY-MM-DD') == start_time ||
          moment(endTime).format('YYYY-MM-DD') == end_time
        ) {
          return
        } else {
          const st = moment(start_time).add(1, 'days').format('YYYY-MM-DD')
          const et = moment(end_time).add(1, 'days').format('YYYY-MM-DD')
          dispatch(getPeriod({ start_time: st, end_time: et }))
        }
      }
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubShift/action.js